import { useState } from "react";
import { FormControl, Grid2, IconButton, Paper, Stack, TextField, Typography } from "@mui/material";
import { formatEditPageInput, stationContactValidator } from "./EditPageUtils";
import EditRowButtons from "./EditRowButtons";
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';

export default function ContactsEditRow({...params}){

    let channelAttributeIndex = params.channelAttributeIndex
    let disabledState = params.disabledState
    let formattedName = params.formattedName
    let oldValue = params.oldValue
    let rowErrorState = params.rowErrorState
    let setDisabledState = params.setDisabledState
    let setRowErrorState = params.setRowErrorState
    let updateNewValues = params.updateNewValues
    let updateRowErrorStates = params.updateRowErrorStates

    let [contacts, setContacts] = useState([...oldValue])
    let [nameErrorStates, setNameErrorStates] = useState(new Array(oldValue.length).fill(false))
    let [emailErrorStates, setEmailErrorStates] = useState(new Array(oldValue.length).fill(false))



    function inputChanged(event, index, inputType){
        event.preventDefault()
        if (rowErrorState === true) setRowErrorState(false)

        if (inputType === 'name') {
            contacts[index].name = event.target.value
            nameErrorStates[index] = false
            setNameErrorStates([...nameErrorStates])
        }

        else if (inputType === 'email') {
            contacts[index].email = event.target.value
            emailErrorStates[index] = false
            setEmailErrorStates([...emailErrorStates])
        }
        setContacts([...contacts])  
    }


    function handleContactsLockClick(){

        

        if (disabledState === true) { 
            setDisabledState(false)
            updateRowErrorStates(channelAttributeIndex, false)
            return;
        }

        else if (disabledState === false && (contacts.length === 0 || (contacts.length === 1 && contacts[0].name === '' && contacts[0].email === ''))){
            setDisabledState(true)
            updateRowErrorStates(channelAttributeIndex, true)
            setContacts([{name: "", email: ""}])
        }

        else if (disabledState === false && contacts === oldValue){
            setDisabledState(true)
            updateRowErrorStates(channelAttributeIndex, true)
            return
        }

        else if (disabledState === false && contacts !== oldValue && contacts.length > 0 && !(contacts.length === 1 && contacts[0].name === '' && contacts[0].email === '')){
            contacts = contacts.filter(contact => (contact.name.length > 0 || contact.email.length > 0))
            setContacts([...contacts])
            updateNewValues(channelAttributeIndex, contacts)
            
            let errors = stationContactValidator(contacts)

            if (errors.length !== 0){
                for (let i = 0; i < errors.length; i++){
                    let errorIndex = errors[i][0]
                    let errorField = errors[i][1]
                    if (errorField === 'name') nameErrorStates[errorIndex] = true
                    else emailErrorStates[errorIndex] = true
                }
                setNameErrorStates([...nameErrorStates])
                setEmailErrorStates([...emailErrorStates])
                setRowErrorState(true)
                updateRowErrorStates(channelAttributeIndex, false)
                return
            }

            else if (errors.length === 0){
                setDisabledState(true)
                setRowErrorState(false)
                contacts = formatEditPageInput(formattedName, contacts)
                setNameErrorStates(new Array(contacts.length).fill(false))
                setEmailErrorStates(new Array(contacts.length).fill(false))
                updateNewValues(channelAttributeIndex, contacts)
                updateRowErrorStates(channelAttributeIndex, true)
            }
        }
    }

    function handleContactsRevertClick(event){
        event.preventDefault()
        setDisabledState(true)
        setContacts([...oldValue])
        setRowErrorState(false)
        setNameErrorStates(new Array(contacts.length).fill(false))
        setEmailErrorStates(new Array(contacts.length).fill(false))
        updateNewValues(channelAttributeIndex, oldValue)
        updateRowErrorStates(channelAttributeIndex, true)
    }


    function upButtonOnClick(event, index){
        event.preventDefault()
        //top case
        if (index === 0){
            let newLastValue = contacts.shift()
            let newLastNameErrorState = nameErrorStates.shift()
            let newLastEmailErrorState = emailErrorStates.shift()

            contacts.push(newLastValue)
            nameErrorStates.push(newLastNameErrorState)
            emailErrorStates.push(newLastEmailErrorState)
        }
        //all other cases
        else {

            let tempValue = contacts[index-1]
            let tempNameErrorState = nameErrorStates[index-1]
            let tempEmailErrorState = emailErrorStates[index-1]

            contacts[index-1] = contacts[index]
            nameErrorStates[index-1] = nameErrorStates[index]
            emailErrorStates[index-1] = emailErrorStates[index]

            contacts[index] = tempValue
            nameErrorStates[index] = tempNameErrorState
            emailErrorStates[index] = tempEmailErrorState
        }
        setNameErrorStates([...nameErrorStates])
        setEmailErrorStates([...emailErrorStates])
        setContacts([...contacts])
        updateNewValues(channelAttributeIndex, contacts)
    }



    function downButtonOnClick(event, index){
        event.preventDefault()
        if (index === contacts.length - 1) {
            let tempValue = contacts.pop()
            let tempNameErrorState = nameErrorStates.pop()
            let tempEmailErrorState = emailErrorStates.pop()

            contacts.unshift(tempValue)
            nameErrorStates.unshift(tempNameErrorState)
            emailErrorStates.unshift(tempEmailErrorState)
        }
        else {
            let tempValue = contacts[index+1]
            let tempNameErrorState = nameErrorStates[index+1]
            let tempEmailErrorState = emailErrorStates[index+1]

            contacts[index+1] = contacts[index]
            nameErrorStates[index+1] = nameErrorStates[index]
            emailErrorStates[index+1] = emailErrorStates[index]

            contacts[index] = tempValue
            nameErrorStates[index] = tempNameErrorState
            emailErrorStates[index] = tempEmailErrorState
        }
        setContacts([...contacts])
        updateNewValues(channelAttributeIndex, contacts)
        setNameErrorStates([...nameErrorStates])
        setEmailErrorStates([...emailErrorStates])
    }

    function trashButtonOnClick(event, index){
        event.preventDefault()
        contacts.splice(index, 1)
        nameErrorStates.splice(index, 1)
        emailErrorStates.splice(index, 1)
        setContacts([...contacts])
        updateNewValues(channelAttributeIndex, contacts)
        setNameErrorStates([...nameErrorStates])
        setEmailErrorStates([...emailErrorStates])

        if (!nameErrorStates.includes(true) && !emailErrorStates.includes(true)) setRowErrorState(false)
    }

    function plusButtonOnClick(event){
        event.preventDefault()
        if (contacts.length > 0 && contacts[contacts.length-1].name === '' && contacts[contacts.length-1].email === '') return
        contacts.push({name: "", email: ""})
        nameErrorStates.push(false)
        emailErrorStates.push(false)
        setContacts([...contacts])
        setNameErrorStates([...nameErrorStates])
        setEmailErrorStates([...emailErrorStates])
        updateNewValues(channelAttributeIndex, contacts)
    }

    function getPlaceHolder(fieldType, currentValue){
        if (currentValue === '' && fieldType === 'email') return 'Email:'
        else if (currentValue === '' && fieldType === 'name') return 'Name:'
        else return formatEditPageInput("", currentValue)
    }


    let buttonsStackDirection = 'column'
    if (contacts.length === 1 && contacts[0].name === "Name:" && contacts[0].email === "Email:") buttonsStackDirection = 'column-reverse'

    if (contacts.length === 0) {
        contacts.push({name: "", email: ""})
        setContacts([...contacts])
    }

    return (
        <Paper sx={{padding: "0.25em", paddingBottom: "0.5em", marginBottom: "0.75em"}} className={"EditRowPaper"}>
            <Stack display={'flex'} justifyContent={'space-evenly'} direction={"row"} width={"100%"}>
                <Typography variant="h6" paddingTop={'2%'}>Station Contact</Typography>
                <EditRowButtons 
                    channelAttributeName={formattedName} 
                    errorState={rowErrorState} 
                    disabledState={disabledState} 
                    handleLockClick={handleContactsLockClick} 
                    handleRevertClick={handleContactsRevertClick}
                />
            </Stack>

            <Grid2 display={'flex'} justifyContent={'space-around'}>
                <FormControl sx={{paddingTop: '1vh', marginTop: '1em'}}>
                    {contacts.map((contact, index) => (
                        <Stack display={'flex'} direction={'row'}>
                            <Stack display={'flex'} direction={buttonsStackDirection}>
                                {(contacts.length > 1) && 
                                    <>
                                        <Stack display={'flex'} direction={'row'}>
                                            <IconButton sx={{paddingLeft:'0%', paddingRight:'0%'}} disabled={disabledState} onClick={(event) => upButtonOnClick(event, index)}>
                                                <NorthIcon justifyContent={'flex-start'} color={"primary"} zIndex={100} sx={{fontSize: "1.25em", fill: "primary.main"}}/>
                                            </IconButton>
                                            <IconButton sx={{paddingLeft:'0%', paddingRight: '0%'}} disabled={disabledState} onClick={(event) => downButtonOnClick(event, index)}>
                                                <SouthIcon justifyContent={'flex-start'} color={"primary"} zIndex={100} sx={{fontSize: "1.25em", fill: "primary.main"}}/>
                                            </IconButton>
                                        </Stack>
                                        <IconButton disabled={disabledState} onClick={(event) => trashButtonOnClick(event, index)}>
                                            <DeleteOutlineIcon justifyContent={'flex-start'} color={"primary"} zIndex={100} sx={{fontSize: "1.25em", fill: "primary.main"}}/>
                                        </IconButton>
                                    </>
                                }

                                {(index === contacts.length - 1 && contacts.length < 3) &&
                                    <IconButton disabled={disabledState} display={'flex'} justifyContent={'flex-start'} sx={{paddingTop:'40%'}} onClick={(event) => plusButtonOnClick(event)}>
                                        <AddIcon justifyContent={'flex-start'} color={"primary"} zIndex={100} sx={{fontSize: "1.25em", fill: "primary.main"}}/>
                                    </IconButton>
                                }
                            </Stack>


                            <Stack display={'flex'}  direction={"column"} spacing={0.5} paddingBottom={'7.5%'}>
                                <TextField
                                    hiddenLabel
                                    placeholder={getPlaceHolder("name", contact.name)}
                                    onChange={(event) => inputChanged(event, index, 'name')}
                                    disabled={disabledState}
                                    value={contact.name}
                                    error={nameErrorStates[index]}
                                />

                                <TextField
                                    hiddenLabel
                                    placeholder={getPlaceHolder("email", contact.email)}
                                    onChange={(event) => inputChanged(event, index, 'email')}
                                    disabled={disabledState}
                                    value={contact.email}
                                    error={emailErrorStates[index]}
                                />
                            </Stack>
                        </Stack>
                    ))}
                </FormControl>
            </Grid2>            
        </Paper>
    )
}
